import type { VNode } from "vue";
import Vue from "vue";
import ColumnFilterComponent from "@/components/controls/grid/columnfilters/ColumnFilterComponent.vue";
import type { CreateElement } from "vue/types/vue";
import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import { Instant } from "@js-joda/core";
import BmDateTime from "@/components/controls/input/BmDateTime.vue";
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";

function isInstant(toTest: any): toTest is Instant {
  return (toTest as Instant)?.epochSecond !== undefined;
}

const dateTimeFilterTypes: FilterType[] = [
  {
    type: "filter_after",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      if (!filterValue) {
        return true;
      }

      return (
        isInstant(itemValue) && itemValue.isAfter(Instant.parse(filterValue))
      );
    },
  },
  {
    type: "filter_before",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      if (!filterValue) {
        return true;
      }

      return (
        isInstant(itemValue) && itemValue.isBefore(Instant.parse(filterValue))
      );
    },
  },
  {
    type: "filter_on_date",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      if (!filterValue) {
        return true;
      }

      const itemDate = tenantService.instantToDate(itemValue);
      const filterDate = tenantService.instantToDate(
        Instant.parse(filterValue)
      );

      return isInstant(itemValue) && itemDate.equals(filterDate);
    },
  },
];

export function buildApplyDateTimeFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, dateTimeFilterTypes);
}

export default Vue.extend({
  name: "DateTimeColumnFilter",
  components: { ColumnFilterComponent },
  render(createElement: CreateElement): VNode {
    return createElement(ColumnFilterComponent, {
      attrs: { ...this.$attrs },
      props: { filterTypes: dateTimeFilterTypes },
      scopedSlots: {
        control1: function (props: any) {
          return createElement(BmDateTime, {
            props: {
              clearable: true,
              value: props.value ? Instant.parse(props.value) : null,
            },
            on: {
              input: function (event: Instant) {
                props.setValue(event?.toString() ?? ""); // ISO-8601
              },
            },
          });
        },
        control2: function (props: any) {
          return createElement(BmDateTime, {
            props: {
              clearable: true,
              value: props.value ? Instant.parse(props.value) : null,
            },
            on: {
              input: function (event: Instant) {
                props.setValue(event?.toString() ?? ""); // ISO-8601
              },
            },
          });
        },
      },
    });
  },
});
